// src/components/ShippingRecord/AddDisputePopin/styles/index.ts
import { createUseStyles } from "$utils/createUseStyles";
import { theme } from "$utils/theme/bataillog";

export const useStyles = createUseStyles({
  wrapper: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    minWidth: 1000,
    maxWidth: 1000,
  },
  popinContainer: {
    display: "flex",
    flex: 1,
  },
  inputContainer: {
    display: "flex",
    flex: 1,
    alignItems: "center",
  },
  linkedEntityContainer: {
    marginLeft: theme.spacing(2),
  },
  lineContainer: {
    display: "flex",
    padding: theme.spacing(2),
  },
  addButtonContainer: {
    width: 30,
    marginLeft: theme.spacing(2),
    alignSelf: "flex-end",
    height: 32,
  },
  addButton: {
    maxWidth: 30,
    minWidth: `30px !important`,
    padding: `${theme.spacing(1)}px !important`,
    height: "100%",
  },
  buttonsContainer: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: theme.spacing(4),
  },
});
